import type { ApiModuleEndpoints } from '../types'

export const inventoryApiEndpoints = {
  transferProductOptions: {
    method: 'GET',
    path: '/inventory/transfer-products/options',
    requiresAuth: true,
  },
  transferSystemProductOptions: {
    method: 'GET',
    path: '/inventory/transfer-products/system-options',
    requiresAuth: true,
  },
  transferOrders: { method: 'GET', path: '/inventory/transfer-orders', requiresAuth: true },
  createTransferOrder: { method: 'POST', path: '/inventory/transfer-orders', requiresAuth: true },
  transferOrderDetail: {
    method: 'GET',
    path: '/inventory/transfer-orders/:id',
    requiresAuth: true,
  },
  updateTransferOrder: {
    method: 'PUT',
    path: '/inventory/transfer-orders/:id',
    requiresAuth: true,
  },
  deleteTransferOrder: {
    method: 'DELETE',
    path: '/inventory/transfer-orders/:id',
    requiresAuth: true,
  },
  submitTransferOrder: {
    method: 'POST',
    path: '/inventory/transfer-orders/:id/submit',
    requiresAuth: true,
  },
  confirmTransferOrder: {
    method: 'POST',
    path: '/inventory/transfer-orders/:id/confirm',
    requiresAuth: true,
  },
  receiveTransferOrder: {
    method: 'PUT',
    path: '/inventory/transfer-orders/:id/receive',
    requiresAuth: true,
  },
  cancelTransferOrder: {
    method: 'PUT',
    path: '/inventory/transfer-orders/:id/cancel',
    requiresAuth: true,
  },
  checks: { method: 'GET', path: '/inventory/checks', requiresAuth: true },
  createInventoryCheck: { method: 'POST', path: '/inventory/checks', requiresAuth: true },
  inventoryCheckDetail: { method: 'GET', path: '/inventory/checks/:id', requiresAuth: true },
  updateInventoryCheck: { method: 'PUT', path: '/inventory/checks/:id', requiresAuth: true },
  balanceInventoryCheck: {
    method: 'POST',
    path: '/inventory/checks/:id/balance',
    requiresAuth: true,
  },
  cancelInventoryCheck: {
    method: 'POST',
    path: '/inventory/checks/:id/cancel',
    requiresAuth: true,
  },
  deleteInventoryCheck: { method: 'DELETE', path: '/inventory/checks/:id', requiresAuth: true },
  copyInventoryCheck: { method: 'POST', path: '/inventory/checks/:id/copy', requiresAuth: true },
  mergeInventoryChecks: { method: 'POST', path: '/inventory/checks/merge', requiresAuth: true },
  stocks: { method: 'GET', path: '/inventory/stocks', requiresAuth: true },
  stockLocations: { method: 'GET', path: '/inventory/stocks/:id/locations', requiresAuth: true },
  updateStockLocations: { method: 'PUT', path: '/inventory/stocks/:id/locations', requiresAuth: true },
  locationTransfers: { method: 'GET', path: '/inventory/location-transfers', requiresAuth: true },
  createLocationTransfer: { method: 'POST', path: '/inventory/location-transfers', requiresAuth: true },
  locationTransferDetail: { method: 'GET', path: '/inventory/location-transfers/:id', requiresAuth: true },
  postLocationTransfer: { method: 'POST', path: '/inventory/location-transfers/:id/post', requiresAuth: true },
  cancelLocationTransfer: { method: 'POST', path: '/inventory/location-transfers/:id/cancel', requiresAuth: true },
  movements: { method: 'GET', path: '/inventory/movements', requiresAuth: true },
  openingStocks: { method: 'GET', path: '/inventory/opening-stocks', requiresAuth: true },
  createOpeningStock: { method: 'POST', path: '/inventory/opening-stocks', requiresAuth: true },
  openingStockDetail: { method: 'GET', path: '/inventory/opening-stocks/:id', requiresAuth: true },
  updateOpeningStock: { method: 'PUT', path: '/inventory/opening-stocks/:id', requiresAuth: true },
  postOpeningStock: {
    method: 'POST',
    path: '/inventory/opening-stocks/:id/post',
    requiresAuth: true,
  },
  cancelOpeningStock: {
    method: 'POST',
    path: '/inventory/opening-stocks/:id/cancel',
    requiresAuth: true,
  },
  purchaseProductOptions: {
    method: 'GET',
    path: '/inventory/purchase-products/options',
    requiresAuth: true,
  },
  purchaseReceipts: { method: 'GET', path: '/inventory/purchase-receipts', requiresAuth: true },
  createPurchaseReceipt: {
    method: 'POST',
    path: '/inventory/purchase-receipts',
    requiresAuth: true,
  },
  purchaseReceiptDetail: {
    method: 'GET',
    path: '/inventory/purchase-receipts/:id',
    requiresAuth: true,
  },
  updatePurchaseReceipt: {
    method: 'PUT',
    path: '/inventory/purchase-receipts/:id',
    requiresAuth: true,
  },
  deletePurchaseReceipt: {
    method: 'DELETE',
    path: '/inventory/purchase-receipts/:id',
    requiresAuth: true,
  },
  postPurchaseReceipt: {
    method: 'POST',
    path: '/inventory/purchase-receipts/:id/post',
    requiresAuth: true,
  },
  cancelPurchaseReceipt: {
    method: 'POST',
    path: '/inventory/purchase-receipts/:id/cancel',
    requiresAuth: true,
  },
  payPurchaseReceiptShipping: {
    method: 'POST',
    path: '/inventory/purchase-receipts/:id/pay-shipping',
    requiresAuth: true,
  },
  purchaseReceiptAttachmentPresign: {
    method: 'POST',
    path: '/inventory/purchase-receipts/:id/attachments/presign',
    requiresAuth: true,
  },
  purchaseReceiptAttachmentConfirm: {
    method: 'POST',
    path: '/inventory/purchase-receipts/:id/attachments/:attachmentId/confirm',
    requiresAuth: true,
  },
  purchaseReceiptAttachmentDelete: {
    method: 'DELETE',
    path: '/inventory/purchase-receipts/:id/attachments/:attachmentId',
    requiresAuth: true,
  },
  returnableItems: {
    method: 'GET',
    path: '/inventory/purchase-receipts/:id/returnable-items',
    requiresAuth: true,
  },
  purchaseReturns: { method: 'GET', path: '/inventory/purchase-returns', requiresAuth: true },
  createPurchaseReturn: { method: 'POST', path: '/inventory/purchase-returns', requiresAuth: true },
  purchaseReturnDetail: {
    method: 'GET',
    path: '/inventory/purchase-returns/:id',
    requiresAuth: true,
  },
  updatePurchaseReturn: {
    method: 'PUT',
    path: '/inventory/purchase-returns/:id',
    requiresAuth: true,
  },
  deletePurchaseReturn: {
    method: 'DELETE',
    path: '/inventory/purchase-returns/:id',
    requiresAuth: true,
  },
  postPurchaseReturn: {
    method: 'POST',
    path: '/inventory/purchase-returns/:id/post',
    requiresAuth: true,
  },
  cancelPurchaseReturn: {
    method: 'POST',
    path: '/inventory/purchase-returns/:id/cancel',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
